module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAc0lEQVR4AWOgC1B06rONmjN16clj5x8ZB00Hcv+DAaY4QgMQ5bVsXbThgrJzP1wDmji6BuuI2buP3lm+5RJcA6Y4QoOuz5QnLz4+f/25feYhuAZMcYSGlOoNx8492nv87rmrz+Aa0MQRGv4TDUZmKA1KAABq4x1SjeEvSQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MQ.png
// module id = 1213
// module chunks = 0